<template>
	<div class="regLogMain">
		<!--邮箱激活01 start-->
    <div class="container">
      <div class="clear sendEmail" v-if="SendOut">
        <div class="l" style="margin: 0 23px 0 177px">
          <img src="../../../assets/img/iconEm1.png" width="96">
        </div>
        <div class="l">
          <h2>Activate your Freightshop account</h2>
          <p>
            Welcome to register. The account activation email has been sent to your email address:&nbsp;
            <b class="colBlack">{{email}}</b>
          </p>
          <div style="margin:25px 0 15px 0">
            <p>The activation email is valid within 24 hours. Please log in your email and click the "activation link" in the </p>
            <p>email to complete the account activation.</p>
          </div>
          <div class="clear">
            <p class="l" style="line-height: 35px;">Haven't received the mail?</p>
            <div class="l">
              <div  class="marL20">
                <a
                  :class='[!this.canClick ? "disabled" : "tranRes"]'
                  class="xBlueBtn"
                  style="height:34px;width:126px;display:inline-block;line-height:34px;"
                  @click="FSendMail()"
                >
                <b>Resend</b>
                </a>
                <a
                  class="xLineBlueBtn marL10"
                  style="height:34px;width:126px;display:inline-block;line-height:34px;"
                  href="/"
                >
                <b>Home</b>
                </a>
              </div>
              <div style="margin: 10px 0 0 15px;">
                <span v-show="!this.canClick"> Try again in
                  <span class="colRed">{{this.totalTime}}</span> seconds
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--邮箱激活01 end-->

      <!--邮箱激活成功 start-->
      <div class="successPage" v-if="Successful">
        <img src="../../../assets/img/iconEm2.png" width="80">
        <div class="textC">
          <h2>Account activation successful</h2>
          <p class="textC">
            Congratulations! Your Freightshop account &nbsp;
            <b class="colBlack">{{email}}</b>&nbsp;has been successfully activated!
          </p>
          <a  class="xBlueBtn loginBtn" style="margin:74px auto"  @click="LandingPage()">Login immediately</a>
        </div>
      </div>
      <!--邮箱激活成功 end-->

      <!--邮箱激活过期 start-->
      <div v-if="fail" class="expire">
        <img src="../../../assets/img/iconEm3.png" width="80">
        <h2 >The account activation link has expired</h2>
        <div class="textC ">
          <a
            class="xBlueBtn"
            :class='[!this.canClick ? "disabled" : "tranRes"]'
            style="width:416px;height:44px;line-height:44px;font-size:16px;margin: auto"
            @click="Resend()"
          >
          Send the account activation email again
          </a>
          <div class="marTop5"  v-show="!this.canClick">
            Try again in
            <span class="colRed">{{this.totalTime}}</span> seconds
          </div>
        </div>
      </div>
    </div>
		<!--邮箱激活过期 end-->
	</div>
</template>

<script type="text/ecmascript-6">
import { post, fetch, Del, put } from "../../../ask/axios";
//按钮防抖
import {_debounce} from "@/ask/util";

  export default {
    components:{},

    data (){
      return {
        api: {
              url: "",
              param: "",
              response: {},
              message: ""
              },
        email:'',
        //发送邮件
        SendOut:true,
        //激活成功 
        Successful:false,
        //激活失败 
        fail:false,
        //倒计时
        ResContent: "Resend",
        totalTimeStart: 120,
        totalTime: 120,
        canClick: true //添加canClick

      }
    },
    created(){
    this.email=this.$route.query.Email;
    //  if(this.$route.query.Email&&!this.$route.query.Vcode){
    //       this.SendMail();
    //  }
    //判断是否四个参数都有
    if(this.$route.query.Email&&this.$route.query.Vcode&&this.$route.query.AccountID&&this.$route.query.SendTime){
      //alert('004')
       this.ActivationSuccessful();
    }else{
     
    }

    },
    methods:{
      //倒计时
      countDown() {
        if (!this.canClick) return; 
        this.canClick = false;
        this.ResContent = this.totalTime
        let clock = window.setInterval(() => {
          this.totalTime--;
          this.ResContent = this.totalTime
          if (this.totalTime < 0) {
            window.clearInterval(clock);
            this.ResContent = "";
            this.totalTime = 120;
            this.canClick = true; //这里重新开启
          }
          
        }, 1000);
      },
      //用来防抖，在一定时间内只会放送一次请求
      FSendMail: _debounce(function(_type, index, item) {
			  this.SendMail();
		  }, 1000),
      //发送邮件 
      SendMail(){
        this.countDown()
        if(this.totalTime < this.totalTimeStart ){
          return
           false
        }
        let that = this;
        that.api.param={
          email:that.$route.query.Email,
      }
      that.api.url=this.$api02+"/api/EbayCustomer/NewAccountInfo/NewAccountInfoSendEmail";
      fetch(that.api.url,that.api.param).then(function (res) {

        if(res.IsOK==true){
          //  注册成功
          //  window.location.href ="/reg/emailAct??Email="+that.EmailId
        }
      })
      },
      //登陆页面跳转
      LandingPage(){
        window.location.href ="/reg/Login"
      },
      Resend(){
        this.FSendMail();
      },
      ActivationSuccessful(){
        let that = this;
        that.api.param={
          email:that.$route.query.Email,
          accountID:that.$route.query.AccountID,
          vcode:that.$route.query.Vcode
      }
      that.api.url=this.$api02+"/api/EbayCustomer/NewAccountInfo/NewAccountInfoCheckEmail";
      fetch(that.api.url,that.api.param).then(function (res) {
        if(res.IsOK==true && res.Results){
           that.SendOut=false;
           that.Successful=true;
        }else{
           that.fail=true;
           that.SendOut=false;
           that.Successful=false;
        }
      })
      },
    }
  }
</script>

<style>
/*局部修改elementUI样式*/
/*!*取消按钮*!*/
/*.el-message-box__wrapper .btn-custom-cancel {float:right;margin:0 120px 0 0 !important;;}*/
/*!*确定或者删除按钮*!*/
/*.el-message-box__wrapper .el-message-box__btns button:nth-child(2){margin:0 0 0 120px !important;}*/
@import "../../../assets/css/tipsMessage.css";
</style>
<style type="text/css" rel="stylesheet" scoped="scoped">
/*邮箱激活*/
.container {
  width: 1200px;
  margin: 0 auto;
  padding-top: 50px;
}

.expire img{
  margin: auto;
}
.expire h2 {
  font-size: 17px;
  color: #041526;
  margin:30px 0 80px 0;
  text-align: center;
}

.sendEmail {
  font-size: 13px;
}
.sendEmail h2{
  font-size: 17px;
  color: #041526;
  margin: 35px 0 25px 0;
}

.successPage img{
  margin: auto;
}
.successPage .loginBtn{
  margin: 74px auto;
  width: 274px;
  height: 44px;
  line-height: 44px;
  font-size: 16px;
}
.successPage h2 {
  font-size: 17px;
  color: #041526;
  margin:22px 0 10px 0;
  text-align: center;
}


.disabled {
	background-color: #ddd !important;
	border-color: #ddd;
	color: #57a3f3;
	cursor: not-allowed;
  transform:scale(1)
}
.tranRes:active{
  transform:scale(0.97)
}
</style>



// WEBPACK FOOTER //
// src/components/reception/reg/emailAct.vue